import { useMutationWithToaster } from "hooks";

const addNewUsersFactory = () => {
  /**
   * {
   *   "userInfos": {
   *     "email": String.required,
   *     "firstName": String.required
   *     "lastName": String.required,
   *     "roleId": ID.required,
   *     "inviteNow": Boolean.required
   *   }
   * }
   */
  const query = `
    mutation addNewUsers($userInfos: [UserInfo]!) {
      addNewUsers(userInfos: $userInfos) {
        newUsers {
          uuid
          name
          email
          lastInviteSentAt
          role {
            title
          }
        }
        warningMessage
      }
    } 
  `;

  const resolver = ({ errors, data: { addNewUsers } }) => {
    if (errors && errors.length) {
      return { data: null, errors: errors };
    }
    return {
      data: {
        newUsers: addNewUsers.newUsers.map(({ uuid, ...props }) => {
          return { ...props, id: uuid };
        }),
      },
    };
  };

  return { query, resolver };
};

const useSubmitNewUsers = (callback) => {
  const [submit, { loading }] = useMutationWithToaster(
    addNewUsersFactory,
    callback
  );

  return {
    loading,
    submit,
  };
};

export default useSubmitNewUsers;
